import { Fragment } from 'react'
import { Row, Col, Spin } from 'antd'
import { useAppSelector } from 'hooks'
import { Question, QuestionGroup, RespondingEntity } from 'Slices/Settings/SettingsSlice'
import { getFatherSettingChilds, getFatherSettings, getQuestionGroupChilds } from 'Helpers/SettingsHelper'
import AnswersColumns from './AnswersColumns'
import AnswersColumnsHeader from './AnswerColumnsHeader'

interface AnswerRowsProps {
  collapse: string[]
  subCollapse: string[]
}

function AnswersRows(props: AnswerRowsProps) {
  const settings = useAppSelector(state => state.present.settings.settings)
  const answers = useAppSelector(state => state.present.settings.answers)
  const isLoading = useAppSelector(state => state.present.settings.isLoading)
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const isOmnichannelAndPricesVisibile = useAppSelector(
    state => state.present.configuration.isOmnichannelAndPricesVisibile,
  )

  const fatherSettingList = getFatherSettings(settings, isOmnichannelAndPricesVisibile, isImagesVisible)

  return (
    <Spin spinning={isLoading} size='large' className='settings-spin-loader'>
      <Row className='answer-row big-table-row'>
        {fatherSettingList.map(([settingsName, questionGroup]: [string, QuestionGroup], id) => {
          const canAddRespondingEntity = settings[settingsName].canAddRespondingEntity
          const questions: Question[] = getQuestionGroupChilds(
            questionGroup,
            isOmnichannelAndPricesVisibile,
            isImagesVisible,
          )
          const extraChild = getFatherSettingChilds(questionGroup)
          const respondingEntities = (answers[settingsName]?.respondingEntities as RespondingEntity[]) ?? []
          return (
            <div
              key={settingsName}
              id={`answer-${settingsName}`}
              className='w-100 position-absolute overflow-x-auto overflow-y-hidden'
            >
              <Col span={24} className={`sub-row ${props.collapse.indexOf(settingsName) !== -1 ? '' : 'd-none'}`}>
                <AnswersColumnsHeader
                  respondingEntities={respondingEntities}
                  settingsName={settingsName}
                  userCanEdit={true}
                  canAddRespondingEntity={canAddRespondingEntity}
                />
              </Col>
              {props.collapse.indexOf(settingsName) !== -1 ? (
                <Col span={24} className={`sub-row ${props.collapse.indexOf(settingsName) !== -1 ? 'expanded' : ''} `}>
                  {questions.map((question: Question, id) => {
                    return (
                      <Fragment key={id}>
                        <AnswersColumns question={question} respondingEntities={respondingEntities} />
                      </Fragment>
                    )
                  })}
                  {extraChild.map((childValue: QuestionGroup) => {
                    const questions: Question[] = getQuestionGroupChilds(
                      childValue,
                      isOmnichannelAndPricesVisibile,
                      isImagesVisible,
                    )
                    return (
                      <Fragment key={childValue.name}>
                        <Col className='sub-sub-row'>
                          <div className='d-inline-block'>{/*Empty child*/}</div>
                        </Col>
                        {props.subCollapse.indexOf(childValue.name) !== -1 ? (
                          <Col
                            span={24}
                            className={`sub-sub-row ${
                              props.subCollapse.indexOf(childValue.name) !== -1 ? 'expanded' : ''
                            }`}
                          >
                            {questions.map((question: Question, id) => {
                              return (
                                <Fragment key={id}>
                                  <AnswersColumns question={question} respondingEntities={respondingEntities} />
                                </Fragment>
                              )
                            })}
                          </Col>
                        ) : null}
                      </Fragment>
                    )
                  })}
                </Col>
              ) : null}
            </div>
          )
        })}
      </Row>
    </Spin>
  )
}

export default AnswersRows
